import PageLayout from "@/components/layout/PageLayout";
import PageBreadcrumb from "@/components/layout/PageBreadcrumb";

const TermsPage = () => {
  return (
    <PageLayout>
      <PageBreadcrumb currentPage="Terms & Conditions" />
      <section className="py-6 sm:py-8 px-4 bg-gradient-to-b from-white to-purple-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8 animate-fade-up">
            <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-primary-dark">Terms and Conditions</h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-neutral mb-6">Last updated: {new Date().toLocaleDateString()}</p>
              
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">1. Agreement to Terms</h2>
                  <p className="text-neutral mb-4">
                    By accessing or using KoverKing's services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.
                  </p>
                  <p className="text-neutral mb-4">
                    These terms apply to all users, visitors, and others who wish to access or use our services.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">2. Insurance Services</h2>
                  <p className="text-neutral mb-4">
                    KoverKing provides comprehensive insurance brokerage services. Our services include:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Connecting clients with reputable insurance providers</li>
                    <li>Assisting with policy selection and customization</li>
                    <li>Processing claims and providing support</li>
                    <li>Offering ongoing policy management</li>
                    <li>Providing insurance consultation and advice</li>
                    <li>Regular policy reviews and updates</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">3. User Responsibilities</h2>
                  <p className="text-neutral mb-4">
                    When using our services, you agree to:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Provide accurate and complete information</li>
                    <li>Maintain and promptly update your contact information</li>
                    <li>Comply with all applicable laws and regulations</li>
                    <li>Protect your account credentials</li>
                    <li>Report any unauthorized access or security issues</li>
                    <li>Use our services in good faith</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">4. Service Modifications</h2>
                  <p className="text-neutral mb-4">
                    We reserve the right to:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Modify or discontinue any part of our services</li>
                    <li>Change service fees with appropriate notice</li>
                    <li>Update these terms as needed</li>
                    <li>Limit service availability in certain regions</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">5. Intellectual Property</h2>
                  <p className="text-neutral mb-4">
                    All content, features, and functionality of our services, including but not limited to:
                  </p>
                  <ul className="list-disc pl-6 mb-6 text-neutral space-y-2">
                    <li>Text, graphics, logos, and images</li>
                    <li>Software and technology</li>
                    <li>Website design and functionality</li>
                    <li>Service marks and trademarks</li>
                  </ul>
                  <p className="text-neutral">
                    Are owned by KoverKing or its licensors and protected by intellectual property laws.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default TermsPage;